/* eslint-disable import/prefer-default-export */
import { UseQueryOptions, UseQueryResult } from "@tanstack/react-query";
import { getScheduleOption } from "api/services/location";
import { getScheduleOptionResponseType } from "api/response/location.response";
import { useCustomQuery } from "hooks/useCustomQuery";
import { locationQueryKeys } from "./locationQueryKeys";

export const useGetScheduleOptions = (
  location: string,
  options?: UseQueryOptions<getScheduleOptionResponseType, unknown>,
): UseQueryResult<getScheduleOptionResponseType> =>
  useCustomQuery<getScheduleOptionResponseType>({
    queryKey: locationQueryKeys.scheduleOptions(location),
    queryFn: () => getScheduleOption(location).then((res) => res.data),
    ...options,
  });
